import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {ICellRendererAngularComp} from 'ag-grid-angular';
import {Observable} from 'rxjs';
import {FormControl} from '@angular/forms';
import {CfcAgGridValidationRendererComponent} from '../cfc-validation-renderer';

@Component({
  selector: 'app-cfc-select-multi-renderer',
  templateUrl: './cfc-select-multi-renderer.component.html',
  styleUrls: ['./cfc-select-multi-renderer.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class CfcSelectMultiRendererComponent implements ICellRendererAngularComp {
  status: string = 'valid';
  values: any;
  public formControl: FormControl;
  // key;
  public value;
  public label: string = '';
  // columnName: string;
  params;
  public className: string;
  // private rowId: number;

  errorVisible: any;

  constructor() { }

  agInit(params: any): any {
    this.values = params.values ? params.values : [];
    this.className = params.className ? params.className : '';
    this.params = params;

    this.value = params.getValue();
    if (Array.isArray(this.values)) {
      this.label = this.findValue(this.values);
    } else {
      const observable: Observable<any> = this.values;
      observable.subscribe(data => {
        this.label = this.findValue(data);
      });
    }

    if (params.vstatus) {
      const _valueStatus = ((typeof params.vstatus === 'function'
        ? params.vstatus(params)
        : params.vstatus) || {}).status as string || '';
      this.status = _valueStatus.toLowerCase();
    }
  }

  findValue(arr: Array<any>): string {
    var matchedItem = '';
    var valueArr = this.value;
    if (valueArr && valueArr.length) {
      valueArr.forEach((element, index) => {
        matchedItem = matchedItem ? matchedItem + ',' + (arr.find(item => item.value === element)).label : (arr.find(item => item.value === element)).label;
      });
    }
    return matchedItem;
  }

  refresh(params: any): boolean {
    // this.value = params.value;
    // if (Array.isArray(this.values)) {
    //   this.label = this.findValue(this.values);
    // } else {
    //   const observable: Observable<any> = this.values;
    //   observable.subscribe(data => {
    //     this.label = this.findValue(data);
    //   });
    // }
    return true;
  }

  labelClick(event: any): void {
    if (this.params && this.params.click) {
      this.params.click(this.params);
    }
  }

}
